export const MainText = () => {
  return (
    <>
      SW캠프와 함께 하세요.
      <br />
      12주 뒤에는 내 커리어에
      <br />
      IT 역량이 더해집니다.
    </>
  );
};
